module.exports = __webpack_public_path__ + "static/media/CATGenerator.ee8272ec.png";